module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"followedArtists":"Deine Lieblingskünstler","noFollowedArtists":"Du folgst bisher niemandem."},"en":{"followedArtists":"Your favorite artists","noFollowedArtists":"You are not following anyone yet."}}')
  delete Component.options._Ctor
}
